module.exports = __webpack_public_path__ + "9aff9fe0.svg";